
























import Vue from 'vue';
import { get } from 'vuex-pathify';
export default Vue.extend({
  name: 'LayoutsApp',

  computed: {
    appLoaded: get<boolean>('app/appLoaded')
  },
  components: {
    LayoutAppBar: () => import('./AppBar.vue'),
    LayoutDrawer: () => import('./Drawer.vue'),
    LayoutRightDrawer: () => import('./RightDrawer.vue'),
    LayoutFab: () => import('./Fab.vue'),
    // LayoutToc: () => import("./Toc.vue"),
    LayoutView: () => import('./View.vue')
  }
});
